var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrand = function SvgBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 39,
    viewBox: "0 0 100 39"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "0%",
    x2: "100%",
    y1: "67.272%",
    y2: "48.646%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04e45c"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00eb52"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: "3.74%",
    x2: "166.666%",
    y1: "47.119%",
    y2: "-13.336%"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7a9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01d767"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "g",
    x1: "34.208%",
    x2: "39.025%",
    y1: "30.333%",
    y2: "0%"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "h",
    x1: "30.683%",
    x2: "16.981%",
    y1: "33.343%",
    y2: "0%"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "i",
    x1: "3.095%",
    x2: "117.844%",
    y1: "48.104%",
    y2: "21.652%"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M28.76 24.5c-.355 4.615-3.018 14.202-11.54 14.202h-5.325c-2.13 0-5.859-1.243-7.102-6.214q-1.242-4.97 5.326-6.923h8.877c4.97 0 8.344-.71 9.764-1.065"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M25.565 12.96Q23.08 25.565 13.492 25.565c-10.651 0-7.988 13.137-1.065 13.137C5.681 38.702 0 34.264 0 26.452c0-8.521 5.681-12.96 13.492-12.96q7.812 0 12.073-.532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M25.565 12.96Q23.08 25.565 13.492 25.565c-10.651 0-7.988 13.137-1.065 13.137C5.681 38.702 0 34.264 0 26.452c0-8.521 5.681-12.96 13.492-12.96q7.812 0 12.073-.532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M25.565 12.96Q23.08 25.565 13.492 25.565c-10.651 0-7.988 13.137-1.065 13.137C5.681 38.702 0 34.264 0 26.452c0-8.521 5.681-12.96 13.492-12.96q7.812 0 12.073-.532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M25.565 12.96Q23.08 25.565 13.492 25.565c-10.651 0-7.988 13.137-1.065 13.137C5.681 38.702 0 34.264 0 26.452c0-8.521 5.681-12.96 13.492-12.96q7.812 0 12.073-.532"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M12.066.482q14.958.01 17.04-.012 2.808-.03 4.817-.44-2.155 13.732-11.996 13.732h-9.87C5.45 13.762.094 19.118.094 25.725v1.745-15.025C.094 5.838 5.45.482 12.057.482z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#24cf5f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.142 33C90.584 33 93 30.46 93 27.427c0-3.633-3.127-4.727-5.934-5.82-2.203-.776-4.335-1.517-4.335-3.422 0-1.552 1.173-2.892 3.73-2.892 1.742 0 3.128.74 4.443 1.693l1.385-1.87C90.832 13.952 88.736 13 86.462 13c-4.122 0-6.503 2.363-6.503 5.326 0 3.245 3.056 4.515 5.792 5.503 2.168.776 4.477 1.693 4.477 3.739 0 1.764-1.314 3.175-3.98 3.175-2.416 0-4.121-.918-5.791-2.293L79 30.39C80.812 31.87 83.406 33 86.142 33"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 7v22.438C62 31.405 63.635 33 65.653 33H67v-2.85h-1.347c-.404 0-.653-.318-.653-.712V7zM71.987 13v19.935H75V13zM72 7v3h3V7zM97 13v19.935h3V13zM97 7v3h3V7zM58 7h-8.946C45.71 7 43 9.631 43 12.877v14.246C43 30.37 45.71 33 49.054 33H58v-3h-8.946c-1.723 0-3.119-1.205-3.119-2.877V12.877c0-1.672 1.396-2.877 3.119-2.877H58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.949 22H55v-3H44.949z"
  }))))));
};
export default SvgBrand;